<template>
    <tr v-if="item.productId">
        <td>
            <a v-if="item.photo"  :href="item.detailPageUrl"  class="prod-img">
                <img :src="item.photo" alt="">
            </a>
        </td>
        <td>
            <a href="javascript:;" class="prod-name">
                {{item.name}}
            </a>
            <div class="vendor-code">
               {{item.article}}
            </div>
        </td>
        <td class="price" >
            {{item.price}}
        </td>
        <td class="count">
            <b-form-input v-model="quantity" class="my_custom_input_product_quantity"
                          type="number" aria-label="Text input with checkbox"
                          @keyup.enter="changeItemCount"
                          @input="validateQuantity"
                          @change="changeItemCount"
            />
        </td>

        <td class="total-price">
            {{item.totalPrice}}
        </td>
        <td>
            <a v-on:click="deleteitem(item)" href="javascript:;" class="remove">
                <i class="demo-icon icon-union-50"></i>
            </a>
        </td>
    </tr>
</template>

<script>

    /**
     * Компонент для отображения товара на странице корзины
     *
     * @vuedoc
     * @module vue:components/BasketItem
     * @exports vue:components/BasketItem
     */

    export default {
        name: "basket-page-product-item",

        components: {
        },

        props: [
            'item'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string} quantity - Количество товара в корзине
         */
        data() {
            return {
                quantity: "1"
            }
        },

        computed: {
        },
        /**
         * Обновляем количество товаров в корзине
         */
        watch: {
            item() {
                this.prepareProps();
            }
        },

        mounted(){
            this.prepareProps();
        },
        methods: {
            /**
             * Присваеваем значению quantity количество нашего товара
             *
             * @method prepareProps
             */
            prepareProps(){
                this.quantity = this.item.quantity;
            },

            /**
             * Удаляем товар с корзины
             *
             * @method deleteitem
             */
            deleteitem(item){
                this.$store.dispatch('basket/deleteBasketItem',item.basketItemId);
            },

            /**
             * Изменяем количество товара в корзине попутно переверяя его на соблюдение ограничений
             *  - количество товаров в корзине не может быть меньше 1
             *
             *  Если указано неверное количество то возвращаем исходное количество товаров в корзине
             *
             * @method changeItemCount
             */
            changeItemCount(value){
                if(parseInt(this.quantity) <= 0) {
                    this.quantity = this.item.quantity;
                } else {
                    this.$store.dispatch('basket/changeItemCount', {
                        basketItemId: this.item.basketItemId,
    	                quantity: this.quantity
        	        });
                }
            },

            /**
             * Проверяем input на соблюдение условий и если нужно миняем значение на 1
             *
             * @method validateQuantity
             */
            validateQuantity() {
                if (parseInt(this.quantity) <= 0) {
                    this.$nextTick(() => {
                        this.quantity = 1;
                    });
                }
            }
        }
    }


</script>
